import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LessorAreaMakerDto, LessorInfoDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { SurveyAreaTableComponent } from './survey-area-table/survey-area-table.component';

@Component({
  selector: 'cradua-survey-area',
  templateUrl: './survey-area.component.html',
  styleUrls: ['./survey-area.component.scss']
})
export class SurveyAreaComponent implements OnInit {

  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() isLoadingLessorAreaMaker: boolean;
  @Input() lessorAreaMakers: LessorAreaMakerDto[];
  @Output() emitLessorAreaMaker = new EventEmitter<any>();
  @Output() emitLessorAreaMakerDelete = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();
  @ViewChild(SurveyAreaTableComponent) child: SurveyAreaTableComponent;
  surveyForm: FormGroup;
  selectedIndex = null;
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.createSurveyForm();
  }

  createSurveyForm() {
    this.surveyForm = this.fb.group({
      LessorAreaMakerDesc: null,
      PobLatitudeDegree: null,
      PobLatitudeMin: null,
      PobLatitudeSec: null,
      PobLongitudeDegree: null,
      PobLongitudeMin: null,
      PobLongitudeSec: null,
      LessorAreaMakerNorthing: null,
      LessorAreaMakerEasting: null,
      LessorAreaMakerRemarks: null,
    });
  }

  onEdit(value: LessorAreaMakerDto) {
    this.selectedIndex = value['index'];
    this.surveyForm.patchValue(value);
  }

  addNew(formValue: LessorAreaMakerDto) {
    if(this.surveyForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.child.lessorAreaMakerFormArray['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.child.addLessorAreaMaker(formValue);
    }
    this.selectedIndex = null;
    this.surveyForm.reset()
  }

  onSubmit(){
    this.emitLessorAreaMaker.emit(this.child.lessorAreaMakerArrayForm.value['LessorAreaMaker']);
    if(this.child.filteredDelete.length > 0) {
      this.emitLessorAreaMakerDelete.emit(this.child.filteredDelete);
    }

  }

  onReset() {
    this.surveyForm.reset();
    this.selectedIndex = null;
  }

  onBack() {
    this.emitTask.emit('list');
  }
}
